import { memo, useCallback } from "react";
import { InfoTooltip } from "../../common/components";
import { Flexbox } from "../../core/components";
import { VendorDataEntryModel, VendorDataRestictions, VendorDataErrorMessages } from "../models";
import { type VendorDataChangedAction } from "../vendorDataReducer";
import { VendorDataInput } from "./VendorDataInput";

interface VendorDataTitleInputProps {
    isDuplicate: boolean;
    disabled: boolean;
    entry: VendorDataEntryModel;
    onVendorDataChanged: (event: VendorDataChangedAction) => void;
}

export const VendorDataTitleInput = memo<VendorDataTitleInputProps>(function VendorDataTitleInput({
    entry,
    onVendorDataChanged,
    isDuplicate,
    disabled,
}) {
    const {
        data: { key },
    } = entry;

    const updateKey = useCallback(
        (newKey: string, isValid: boolean) => {
            onVendorDataChanged({
                type: "update",
                entry: entry.setKey(newKey, isValid),
            });
        },
        [entry, onVendorDataChanged],
    );

    const validateTitle = useCallback((newValue: string) => !!newValue, []);
    const error = useCallback(() => VendorDataErrorMessages.ShouldNotBeEmpty, []);

    return (
        <VendorDataInput
            name="dataTitle"
            value={key as string}
            label={
                <Flexbox>
                    Attribute Name
                    <InfoTooltip content="Key used to access Vendor Data" />
                </Flexbox>
            }
            disabled={disabled}
            maxLength={VendorDataRestictions.maxTitleLength}
            onChanged={updateKey}
            isDuplicate={{ isActive: isDuplicate, message: VendorDataErrorMessages.TitleIsDuplicated }}
            validator={validateTitle}
            error={error}
            data-testid={`vendor-data-title-input-${entry.index}`}
        />
    );
});
